query GetUserPermissions {
  permissions {
    policy
  }
}
